import { render, staticRenderFns } from "./updata.vue?vue&type=template&id=7444c5cc&scoped=true"
import script from "./updata.vue?vue&type=script&lang=js"
export * from "./updata.vue?vue&type=script&lang=js"
import style0 from "./updata.vue?vue&type=style&index=0&id=7444c5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7444c5cc",
  null
  
)

export default component.exports